module.exports = __webpack_public_path__ + "static/media/Sohel_Bargir.95986cd6.png";